module.exports = require('./readable').Transform



//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/Prod_web-client/node_modules/readable-stream/transform.js
// module id = EJO3
// module chunks = 15